import React, { MutableRefObject, useRef, useEffect } from "react";

import { useIntl } from "react-intl";
import ButtonPayment from "../Common/ButtonPayment";

// Types
type MessageContentHTMLProps = {
  content: string;
  overrideCSS?: boolean
};

export const handleNavigationMessage = ({
  content = "",
  contentPayload = null,
} = {},
intl:any) => {
  if (
    content.includes("{กดเพื่อยืนยันการจัดส่งยา}") ||
    contentPayload?.target === "drug_address"
  ) {
    console.log("Debug ~ content:", content)
    return (
      <>
        {handleSetupMessageHtml(content.replace(/{กดเพื่อยืนยันการจัดส่งยา}/g, ""), undefined)}
        {/* <div
      dangerouslySetInnerHTML={{
        __html: content.replace(/{กดเพื่อยืนยันการจัดส่งยา}/g, ""),
      }}
    /> */}
        <ButtonPayment
          title={intl.formatMessage({ id: "bplusClinicKey1352" })}
          // callback
          // onClick={() =>
          //   (window.location.href = `/payment/${"telemed"}/?app=MobPayment&channelid=${channelId}`)
          // }
        />
      </>
    );
  } else {
    return handleSetupMessageHtml(content,undefined) ;
  }
};

export const handleSetupMessageHtml = (content:any,href:any) => {
  if (href) {
    const hrefString = `<a href='/${href}'$1>`
    const replacedTagA = content.replace(/<a(?![^>]*href=)([^>]*)>/gi, hrefString);
    return <MessageContentHTML content={replacedTagA} />
  } else {
    const replacedTagA = content.replace(/<a\b([^>]*)>(.*?)<\/a>/gi, '');   
    return <MessageContentHTML content={replacedTagA} />
  }
}

const MessageContentHTML = (props: MessageContentHTMLProps) => {
  const intl = useIntl();

  const contentRef = useRef() as MutableRefObject<HTMLDivElement>;

  useEffect(() => {
    if (contentRef.current) {
      const datai18n = document.querySelectorAll("[data-i18n-en]");
      let lang = intl.locale as "th" | "en";

      if (lang.includes("-")) {
        lang = intl.locale.split("-")[0] === "th" ? "th" : "en"
      }

      for (const elm of Array.from(datai18n)) {
        const messages = {
          th: elm.getAttribute("data-i18n-th"),
          en: elm.getAttribute("data-i18n-en"),
        };

        elm.innerHTML = messages[lang] || "";
      }

      contentRef.current.style.opacity = "1";
    }
  }, [contentRef.current, props.content]);

  return (
    <div
      ref={contentRef}
      className={props.overrideCSS ? "message-content" : undefined}
      style={{ opacity: 0 }}
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  );
};

export default React.memo(MessageContentHTML);
